<template>
	<InformationBanner v-show="show">
		<slot name="default" />
		<template #additional-content>
			<div class="ml-auto">
				<Button
					icon="times"
					type="tertiary"
					icon-size="sm"
					class="text-blue-900"
					aria-label="Dismiss banner"
					@click="handleDismiss"
				></Button>
			</div>
		</template>
	</InformationBanner>
</template>

<script>
import InformationBanner from './InformationBanner'
import Button from '~/components/ui/common/Button'

export default {
	name: 'DismissableBanner',
	components: {
		InformationBanner,
		Button
	},
	props: {
		showWhen: {
			type: Boolean,
			required: true
		},
		resourceId: {
			type: [String, Number],
			required: false,
			default: null
		},
		resourcePrefix: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			dismissed: false
		}
	},
	computed: {
		storageKey() {
			const id =
				this.resourceId != null ? this.resourceId.toString() : 'global'
			return `${this.resourcePrefix}-${id}`
		},
		show() {
			return this.showWhen && !this.dismissed
		}
	},
	mounted() {
		this.loadDismissState()
	},
	watch: {
		resourceId: {
			immediate: true,
			handler() {
				this.loadDismissState()
			}
		}
	},
	methods: {
		loadDismissState() {
			if (!process.client) {
				return
			}

			this.dismissed = !!localStorage.getItem(this.storageKey)
		},
		handleDismiss() {
			if (!process.client) {
				return
			}

			this.dismissed = true
			localStorage.setItem(this.storageKey, '1')
		}
	}
}
</script>
